import axios from "axios";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { setBlogItems, setStoreItems } from "../store/store";
import useAsyncRequest from "./useAsyncRequest";
const server = `https://${window["APP_HOST_SERVER"]}`;
const customer_id = window["customer_id"];
export const media_url = (media) => {
  return `${server}/djmedia/${media}`;
};

const blogUrls = {
  post: {
    list: `${server}/api/v2/blog/post/`,
    detail: `${server}/api/v2/blog/post/detail/`,
  },
  page: {
    list: `${server}/api/v2/blog/page/`,
    detail: `${server}/api/v2/blog/page/detail/`,
    getPublicFile: `${server}/api/v2/blog/page/getPublicFile/`,
  },
};
export const useBlog = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { currentCustomer } = useSelector((state) => state.store);
  const { api } = useAsyncRequest();

  const getMainBlog = async () => {
    try {
      const response = await api(blogUrls.page.list, {
        customer_id: currentCustomer?.id || window["customer_id"],
      });
      if (response.data.res === 1) {
        dispatch(
          setBlogItems({
            ...response.data.data,
            loaded: true,
            loading: false,
          })
        );
        dispatch(
          setStoreItems({
            loading: false,
            loaded: true,
          })
        );
        return response.data.data;
      } else {
        enqueueSnackbar(
          response.data?.message || "Error cargando las noticias",
          { variant: "error" }
        );
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getPosts = async (page, page_size) => {
    try {
      const response = await api(blogUrls.post.list, {
        customer_id: currentCustomer?.id || window["customer_id"],
        page,
        page_size,
      });
      if (response.data.res === 1) {
        dispatch(
          setBlogItems({
            posts: response.data.data,
            postsPages: response.data.pages,
            postsCount: response.data.count,
            recentPosts: response.data.recent_posts,
          })
        );
        return response.data.data;
      } else {
        enqueueSnackbar(
          response.data?.message || "Error cargando las noticias",
          { variant: "error" }
        );
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getPost = async (id) => {
    try {
      const response = await api(blogUrls.post.detail, {
        customer_id: currentCustomer?.id || window["customer_id"],
        id,
      });
      if (response.data.res === 1) {
        dispatch(
          setBlogItems({
            currentPost: response.data.data,
            recentPosts: response.data.data.recent_posts || [],
          })
        );
        return response.data.data;
      } else {
        enqueueSnackbar(response.data?.message || "Error cargando la noticia", {
          variant: "error",
        });
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const pageDetail = async (slug) => {
    try {
      const response = await api(blogUrls.page.detail, {
        customer_id: currentCustomer.id,
        slug,
      });
      if (response.data.res === 1) {
        dispatch(setBlogItems({ currentPage: response.data.data }));
        return response.data.data;
      } else {
        enqueueSnackbar(response.data?.message || "Error cargando la página", {
          variant: "error",
        });
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getPagePublicFile = async (data) => {
    try {
      const response = await api(blogUrls.page.getPublicFile, {
        customer_id: currentCustomer.id,
        ...data,
      });
      if (response.data.res === 1) {
        return response.data.data;
      } else {
        enqueueSnackbar(
          response.data?.message || "Error cargando los archivos",
          { variant: "error" }
        );
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  return {
    getMainBlog,
    getPosts,
    getPost,
    page: {
      detail: pageDetail,
      getPublicFile: getPagePublicFile,
    },
  };
};
